import { ChannelCreate } from '@aicon-dev/caas-chat';

import { useModals, useNavigate } from '~/router';

export default function ChatCreateModal() {
  const modals = useModals();
  const navigate = useNavigate();

  return (
    <ChannelCreate
      onClose={() => modals.close()}
      onCreated={(channel) => {
        navigate('/chat/:chatId', {
          params: { chatId: channel?.url ?? '' },
        });
      }}
    />
  );
}
